<template>
  <div id="app" >
    <TopHeader />
    <div class="container mx-auto">
      <div v-show="windowWidth <= 990">
        <MobileMenu />
        
      </div>
      <div v-show="windowWidth >= 990">
        <SiteMenu v-if="$route.name != 'scan' && $route.name != 'scan-table'" />
      </div>
      <!-- Comment the whole div when we don't need this banners (banner) -->
      <!-- <div>
        <img v-if="$route.name == 'home' || $route.name == 'product' || $route.name == 'products'" class="mt-3 px-5" src="@/assets/images/sale10.png">
        <img v-if="$route.name == 'home' || $route.name == 'products'" class="mt-3 px-5" src="@/assets/images/new_year_holiday.jpg">
        <img v-if="$route.name == 'home' || $route.name == 'products'" class="mt-3 px-5" src="@/assets/images/EASTER.jpg">
      </div> -->
      <Breadcrumb v-if="$route.name != 'home' && $route.name != 'product'" />
      <router-view class="p-3" />
      <notifications style="z-index: 9999;"
        group="address"
        position="top right"
        classes="bg-teal-400 text-teal-400 m-2 p-4 rounded-lg shadow-lg"
      />
      <notifications style="z-index: 9999;"
        group="profile"
        position="top right"
        classes="bg-teal-400 text-teal-400 m-2 p-4 rounded-lg shadow-lg"
      />
      <notifications style="z-index: 9999;"
        group="auth"
        position="top right"
        classes="bg-teal-400 text-teal-400 m-2 p-4 rounded-lg shadow-lg"
      />
      <notifications style="z-index: 9999;"
        group="cart"
        position="top right"
        classes="bg-teal-400 text-teal-400 m-2 p-4 rounded-lg shadow-lg"
      />
      <notifications style="z-index: 9999;"
        group="alert"
        position="top right"
        classes="bg-teal-400 text-red-500 m-2 p-4 rounded-lg shadow-lg"
      />
    </div>
    <Footer v-if="$route.name != 'scan' && $route.name != 'scan-table'" />
  </div>
</template>

<script>
import TopHeader from "./components/pages/TopHeader.vue";
import SiteMenu from "./components/partials/menu/SiteMenu.vue";
import MobileMenu from "./components/partials/menu/MobileMenu.vue";
// import MobileMenuSticky from "./components/partials/menu/MobileMenuSticky.vue";
import Breadcrumb from "./components/partials/menu/Breadcrumb.vue";
import Footer from "./components/partials/footer/Footer.vue";

export default {
  name: "app",
  components: {
    TopHeader,
    SiteMenu,
    Breadcrumb,
    Footer,
    MobileMenu,
    // MobileMenuSticky
  },
  data() {
    return {
      languages: [
        { flag: "us", language: "en", title: "English" },
        { flag: "de", language: "de", title: "Deutch" },
      ],
      windowWidth: window.innerWidth,
      txt: "",
     
    };
  },
  watch: {
    windowWeight(newValue, old) {
      this.txt = `it changed to ${newValue} from ${old}`;
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
    
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
   
  },
  methods: {
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.isSticky = scrollTop > 65;
    },
  },
};
</script>

<style>
@import "./assets/css/tailwind.css";



@media (min-width: 415px) and (max-width: 450px) {
  .app-500 {
    width: 494px;
  }
  

}
#app{
  background-color:#f1f0f04d;
  overflow: hidden;
    width: 100%;
}

</style>
